// extracted by mini-css-extract-plugin
module.exports = {"breakpointMedium":"500px","breakpointLarge":"790px","breakpointSticky":"500px","editionSelect":"editionSelect__2jZs3","select":"select__2FQi5"};